import { useContext, useEffect } from 'react';
import { branchTermSingular } from 'utils/terminology';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import HookFormRadioContainer from 'components/cef_form/hook-form/HookFormRadioContainer';
import DocumentLink from 'components/ui-components/DocumentLink';
import MetaHelmet from 'helpers/MetaHelmet';
import StepTemplate from '../StepTemplate';

const AdditionalContent = () => (
  <>
    <h3 className="ff-body fw-700 fs-18 lh-1 tc-main">
      Download the Trade Account application
    </h3>

    <p className="fw-400 tc-main">
      If you prefer, you can apply by post or drop off the printed form below at
      your nearest{' '}
      <a className="td-u" href="/stores" target="_blank">
        CEF {branchTermSingular}
      </a>
      .
    </p>

    <DocumentLink
      text="Trade Account Application Form"
      type="PDF"
      link="https://assets.cef.co.uk/misc/cef/CEF_Account_Application.pdf"
    />
  </>
);

const Step1 = () => {
  const { setValue, reset, companyTypes, setCurrentStep, setReachedStep } =
    useContext(HookFormContext);

  /**
   * This correctly sets the currentStep after using the browser Back/Forward controls.
   * For example if a users on step 3, then goes back to step 1 and clicks Continue
   * they're brought to step 2 instead of step 4
   */
  useEffect(() => {
    setCurrentStep(1);
  }, []);

  // TODO: This might be moved later to be more reusable
  const handleReset = (fieldName, fieldValue) => {
    reset(); // Reset all form fields

    setValue(fieldName, fieldValue); // Set the value of Company Type again

    setReachedStep(0);
  };

  return (
    <>
      <MetaHelmet />

      <StepTemplate additionalContent={<AdditionalContent />}>
        <HookFormRadioContainer
          variant="feature"
          id="company_type"
          label="Please select your Company Type"
          radioItems={companyTypes}
          onChange={handleReset}
        />
      </StepTemplate>
    </>
  );
};

export default Step1;
